module.exports = __webpack_public_path__ + "img/Bard.f8dfb52f.png";